import React from 'react';
import type { ProjectCategory } from '../../types/content';
export type WorkFilter = 'All' | ProjectCategory;
interface WorkFiltersProps {
  filters: {
    label: WorkFilter;
    count: number;
  }[];
  activeFilter: WorkFilter;
  onChange: (filter: WorkFilter) => void;
}
export function WorkFilters({
  filters,
  activeFilter,
  onChange
}: WorkFiltersProps) {
  return <div role="group" aria-label="Filter work by discipline" className="flex flex-wrap items-center gap-2" data-id="element-903" data-mp="sdqa53qqao2o">
      {filters.map(filter => {
      const isActive = filter.label === activeFilter;
      return <button key={filter.label} type="button" onClick={() => onChange(filter.label)} aria-pressed={isActive} className={`inline-flex h-10 cursor-pointer items-center gap-2 rounded-full border px-4 text-small outline-none transition-colors duration-200 ease-out focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 ${isActive ? 'border-ink bg-ink text-white' : 'border-hairline bg-canvas text-muted hover:border-ink hover:text-ink'}`} data-id="element-904" data-mp="egjsxdlnkxfk">
            {filter.label}
            <span className={`text-[12px] tabular-nums ${isActive ? 'text-white/60' : 'text-muted'}`} data-id="element-905" data-mp="129jdtlnl9yx8">
              {filter.count}
            </span>
          </button>;
    })}
    </div>;
}